import { render, staticRenderFns } from "./UCButton.vue?vue&type=template&id=3cdbe108&scoped=true&"
import script from "./UCButton.vue?vue&type=script&lang=ts&"
export * from "./UCButton.vue?vue&type=script&lang=ts&"
import style0 from "./UCButton.vue?vue&type=style&index=0&id=3cdbe108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbe108",
  null
  
)

export default component.exports